export default class RegexUtils {
  /**
   * Extracts all digits from the provided string.
   *
   * @param {string} str the string to format
   * @return {string} the digits portion of the string
   */
  static getDigits(str) {
    return str.replace(/\D/g, '');
  }

  /**
   * Format the provided phone number as (###)-###-####.
   *
   * @param {string} phoneNumber the phone number to format
   * @return {string} the formatted phone number
   */
  static formatPhoneNumber(phoneNumber) {
    const digitsOnly = RegexUtils.getDigits(phoneNumber);
    const matches = digitsOnly.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !matches[2]
      ? matches[1]
      : `(${matches[1]}) ${matches[2]}${matches[3] ? `-${matches[3]}` : ''}`;
  }

  /**
   * Validate that the provided email has an @ sign and a . in the second part
   * of the string.
   *
   * @param {string} email the email to validate
   * @return {boolean} whether or not the email is valid
   */
  static validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  /**
   * Validate that the provided value does not contain any numbers.
   *
   * @param {string} value the value to validate
   * @return {boolean} whether or not any numbers exist in the value
   */
  static validateNoNumbers(value) {
    const re = /\d+/;
    return !re.test(value);
  }

  /**
   * Validate that the provided value only contains numbers and dashes.
   *
   * @param {string} value the value to validate
   * @return {boolean} whether or not any characters other than numbers and
   * dashes exist in the value
   */
  static validateOnlyNumberAndDashes(value) {
    const re = /^[0-9-]*$/;
    return re.test(value);
  }
}
